// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as VerificationRouteImport } from './routes/verification'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as EnquiryConfirmationRouteImport } from './routes/enquiry-confirmation'
import { Route as DestinationsRouteImport } from './routes/destinations'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as AboutUsRouteImport } from './routes/about-us'
import { Route as IndexRouteImport } from './routes/index'
import { Route as UsefulInfoIndexRouteImport } from './routes/useful-info/index'
import { Route as SafarisIndexRouteImport } from './routes/safaris/index'
import { Route as AccommodationIndexRouteImport } from './routes/accommodation/index'
import { Route as UsefulInfoSlugRouteImport } from './routes/useful-info/$slug'
import { Route as SafarisSlugRouteImport } from './routes/safaris/$slug'
import { Route as FeedbackTokenRouteImport } from './routes/feedback/$token'
import { Route as AccommodationSlugRouteImport } from './routes/accommodation/$slug'

const VerificationRoute = VerificationRouteImport.update({
            id: '/verification',path: '/verification',getParentRoute: () => rootRouteImport
          })
const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const EnquiryConfirmationRoute = EnquiryConfirmationRouteImport.update({
            id: '/enquiry-confirmation',path: '/enquiry-confirmation',getParentRoute: () => rootRouteImport
          })
const DestinationsRoute = DestinationsRouteImport.update({
            id: '/destinations',path: '/destinations',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const AboutUsRoute = AboutUsRouteImport.update({
            id: '/about-us',path: '/about-us',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const UsefulInfoIndexRoute = UsefulInfoIndexRouteImport.update({
            id: '/useful-info/',path: '/useful-info/',getParentRoute: () => rootRouteImport
          })
const SafarisIndexRoute = SafarisIndexRouteImport.update({
            id: '/safaris/',path: '/safaris/',getParentRoute: () => rootRouteImport
          })
const AccommodationIndexRoute = AccommodationIndexRouteImport.update({
            id: '/accommodation/',path: '/accommodation/',getParentRoute: () => rootRouteImport
          })
const UsefulInfoSlugRoute = UsefulInfoSlugRouteImport.update({
            id: '/useful-info/$slug',path: '/useful-info/$slug',getParentRoute: () => rootRouteImport
          })
const SafarisSlugRoute = SafarisSlugRouteImport.update({
            id: '/safaris/$slug',path: '/safaris/$slug',getParentRoute: () => rootRouteImport
          })
const FeedbackTokenRoute = FeedbackTokenRouteImport.update({
            id: '/feedback/$token',path: '/feedback/$token',getParentRoute: () => rootRouteImport
          })
const AccommodationSlugRoute = AccommodationSlugRouteImport.update({
            id: '/accommodation/$slug',path: '/accommodation/$slug',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,AboutUsRoute: AboutUsRoute,ContactRoute: ContactRoute,DestinationsRoute: DestinationsRoute,EnquiryConfirmationRoute: EnquiryConfirmationRoute,TermsRoute: TermsRoute,VerificationRoute: VerificationRoute,AccommodationSlugRoute: AccommodationSlugRoute,FeedbackTokenRoute: FeedbackTokenRoute,SafarisSlugRoute: SafarisSlugRoute,UsefulInfoSlugRoute: UsefulInfoSlugRoute,AccommodationIndexRoute: AccommodationIndexRoute,SafarisIndexRoute: SafarisIndexRoute,UsefulInfoIndexRoute: UsefulInfoIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)